import React from 'react';
import {ReactComponent as Shield} from "../../resources/shield_loader.svg";

export const Loader = ({move}) => (
    <div className={`loader ${move ? 'move' : ''}`}>
        <Shield/>
    </div>
);